<template>
  <div>
    <h1 class="text-4xl text-center">Welke slagboom past bij jou?</h1>

    <p class="text-center">
      Vul de Slagboom Configurator in en krijg antwoord op deze vraag!
    </p>
    <img
      class="mx-auto h-36 w-center my-12"
      src="@//assets/icons/Slagboom-met-auto.svg"
    />

    <div class="my-6 justify-center flex">
      <router-link class="btn-primary text-center font-bold" to="/stap-1"
        >START DE SLAGBOOM CONFIGURATOR!</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  props: {
    pages: Array,
    totalPrice: Number,
  },
  methods: {
    addChild(i) {
      this.$emit("add", i);
    },
    removeChild(i) {
      this.$emit("remove", i);
    },
  },
  inheritAttrs: false, // disable 'non-props' warning
};
</script>
